import { Flex, Box, ButtonIcon } from '@backstage/ui';
import { RiArrowLeftSLine, RiArrowRightSLine } from '@remixicon/react';
import { useSearch } from '@backstage/plugin-search-react';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';
import { LoadingState } from '../../../../shared/components/loading-state';
import { EmptyState } from '../../../../shared/components/empty-state';
import { SearchResultItem } from '../search-result-item';

export const SearchResultList = () => {
  const { result, fetchNextPage, fetchPreviousPage } = useSearch();
  const { t } = useTranslationRef(appTranslationRef);

  if (result.loading) {
    return <LoadingState template="list" rows={5} />;
  }

  if (!result.value?.results.length) {
    return (
      <EmptyState
        title={t('search.noResults')}
        description={t('search.noResultsDescription')}
      />
    );
  }

  const hasNext = Boolean(result.value?.nextPageCursor);
  const hasPrevious = Boolean(result.value?.previousPageCursor);

  return (
    <Flex direction="column" gap="3">
      <Flex direction="column" gap="2">
        {result.value.results.map((item, index) => (
          <SearchResultItem
            key={`${item.document.location}-${index}`}
            title={item.document.title}
            text={item.document.text}
            location={item.document.location}
            kind={(item.document as unknown as Record<string, string>).kind}
            type={item.type}
          />
        ))}
      </Flex>

      {(hasPrevious || hasNext) && (
        <Flex justify="center" gap="2">
          <Box>
            <ButtonIcon
              icon={<RiArrowLeftSLine size={20} />}
              onPress={() => fetchPreviousPage?.()}
              isDisabled={!hasPrevious}
              variant="tertiary"
              size="small"
              aria-label={t('search.previousPage')}
            />
          </Box>
          <Box>
            <ButtonIcon
              icon={<RiArrowRightSLine size={20} />}
              onPress={() => fetchNextPage?.()}
              isDisabled={!hasNext}
              variant="tertiary"
              size="small"
              aria-label={t('search.nextPage')}
            />
          </Box>
        </Flex>
      )}
    </Flex>
  );
};
